import React, { lazy, useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loadable from "./Loadable";

const LandingPage = Loadable(lazy(() => import("../Pages/Home/Landing")));

// Product
const Layout = Loadable(lazy(() => import("./Layout")));
// const ProductList = Loadable(lazy(() => import("../Pages/Product/Shop/Product")));
// const ProductDetail = Loadable(lazy(() => import("../Pages/Product/Shop/ProductDetail")));
// const Cart = Loadable(lazy(() => import("../Pages/Product/Shop/Cart")));
// const Billing = Loadable(lazy(()=> import("../Pages/Product/Shop/Billing")))
// const DeliveryPayment = Loadable(lazy(()=> import("../Pages/Product/Shop/Payment")))

const RestaurantPos = Loadable(
  lazy(() => import("../Pages/Product/RestaurantPos"))
);
const RetailPos = Loadable(
  lazy(() => import("../Pages/Product/RetailPos/RetailPos"))
);
const OnlineOrder = Loadable(
  lazy(() => import("../Pages/Product/Online/Online-Order"))
);
const Ecommerce = Loadable(
  lazy(() => import("../Pages/Product/E-commerce/Ecommerce"))
);
const Kiosk = Loadable(lazy(() => import("../Pages/Product/Kiosk/Kiosk")));
const KDS = Loadable(
  lazy(() => import("../Pages/Product/KDS/KitchenDisplaySystem"))
);

// PAYMENT
const Solo = Loadable(lazy(() => import("../Pages/Product/Payments/MaxPay")));
const MinPay = Loadable(lazy(() => import("../Pages/Product/Payments/MinPay")));
const OverView = Loadable(
  lazy(() => import("../Pages/Product/Payments/OverView"))
);
const Terminal = Loadable(
  lazy(() => import("../Pages/Product/Payments/ProPay"))
);

// FOOD AND BEVERAGE
const FoodDrink = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Food-Drink"))
);
const BarClub = Loadable(lazy(() => import("../Pages/Food-Beverage/Bar-Club")));
const FoodTruck = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Food-Truck"))
);
const GroceryShop = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Grocery-shop"))
);
const MarketStall = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Market-Stall"))
);
const Restaurant = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Restaurant"))
);
const QuickService = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Quick-Service"))
);
const RestaurantOverview = Loadable(
  lazy(() => import("../Pages/Food-Beverage/Overview"))
);

// RETAIL
const Clothing = Loadable(lazy(() => import("../Pages/Retail/Clothings")));
const Garden = Loadable(lazy(() => import("../Pages/Retail/Garden")));
const HomeGift = Loadable(lazy(() => import("../Pages/Retail/HomeGift")));
const WinLiqure = Loadable(lazy(() => import("../Pages/Retail/WinLiqure")));
const RetailOverView = Loadable(lazy(() => import("../Pages/Retail/Overview")));

// Beauty
const Salon = Loadable(lazy(() => import("../Pages/Beauty/Beauty-Salon")));
const Barbershop = Loadable(lazy(() => import("../Pages/Beauty/Barbershop")));
const MedSpa = Loadable(lazy(() => import("../Pages/Beauty/Med-spa")));
const NailSalon = Loadable(lazy(() => import("../Pages/Beauty/Nail-Salon")));
const TattooPiercing = Loadable(
  lazy(() => import("../Pages/Beauty/Tattoo-Piercing"))
);
const DaySpa = Loadable(lazy(() => import("../Pages/Beauty/Day-spa")));
const HairSalon = Loadable(lazy(() => import("../Pages/Beauty/Hair-salon")));
const BeautyOverView = Loadable(
  lazy(() => import("../Pages/Beauty/Beauty-Overview"))
);

// price
const Pricing = Loadable(lazy(() => import("../Pages/Price/Price")));

// Manage Finance
const BusinessAccount = Loadable(
  lazy(() => import("../Pages/Manage-Finances/BusinessAccount"))
);
const CashAdvanced = Loadable(
  lazy(() => import("../Pages/Manage-Finances/CashAdvanced"))
);
const MasterCard = Loadable(
  lazy(() => import("../Pages/Manage-Finances/VisaCard"))
);
const Features = Loadable(
  lazy(() => import("../Pages/Manage-Finances/Features"))
);
const Eligibility = Loadable(
  lazy(() => import("../Pages/Manage-Finances/Eligibility"))
);

// help
const ContactSales = Loadable(
  lazy(() => import("../Pages/Contact/ContactSales"))
);
const Helpandsupport = Loadable(
  lazy(() => import("../Pages/Contact/Helpandsupport"))
);
const Becomepartner = Loadable(
  lazy(() => import("../Pages/Contact/Becomepartner"))
);

// Inventory
const Inventory = Loadable(
  lazy(() => import("../Pages/Product/Inventory/Inventory"))
);

// Sales Form
const SalesForm = Loadable(lazy(() => import("../Pages/Sale-Form/SaleForm")));
const SuccessFull = Loadable(
  lazy(() => import("../Pages/Sale-Form/SucessFull"))
);

// footer page
const Sitemap = Loadable(lazy(() => import("../Components/Pages/Sitemap")));
const TermsCondition = Loadable(
  lazy(() => import("../Components/Pages/Terms"))
);
const Cookies = Loadable(lazy(() => import("../Components/Pages/Cookies")));
const Delivery = Loadable(
  lazy(() => import("../Components/Pages/Delivery-terms"))
);
const Area = Loadable(lazy(() => import("../Components/Pages/Area")));
const AreaInfo = Loadable(lazy(() => import("../Components/Pages/AreaInfo")));
const Partners = Loadable(lazy(() => import("../Pages/Partners/Partners")));
const PrivacyPolicy = Loadable(
  lazy(() => import("../Components/Pages/Privacy-policy"))
);
const DataProcessing = Loadable(
  lazy(() => import("../Components/Pages/DataProcessing"))
);
const AboutUs = Loadable(lazy(() => import("../Components/AboutUs/AboutUs")));

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
    if (pathname.endsWith("e-commerce") || pathname.endsWith("overview")) {
      document.getElementById("app_r")?.classList.remove("overflow-x-hidden");
    } else {
      document.getElementById("app_r")?.classList.add("overflow-x-hidden");
    }

    if(pathname != '/') {
         document.getElementById("body")?.classList.remove("blur");
      }
  }, [pathname]);
};

const AppRoutes = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/restaurant-pos" element={<RestaurantPos />} />
            <Route path="/best-online-ordering" element={<OnlineOrder />} />
            <Route path="/pos-system" element={<RetailPos />} />
            <Route path="/online-ordering" element={<Ecommerce />} />
            <Route path="/self-serve-kiosks" element={<Kiosk />} />
            <Route path="/kitchen-display" element={<KDS />} />

            <Route path="/payments" element={<OverView />} />
            <Route path="/payments/minPay" element={<MinPay />} />
            <Route path="/payments/maxPay" element={<Solo />} />
            <Route path="/payments/proPay" element={<Terminal />} />

            <Route path="/industries/food-drink" element={<FoodDrink />} />
            <Route path="/industries/bar-club" element={<BarClub />} />
            <Route path="/industries/food-truck" element={<FoodTruck />} />
            <Route path="/industries/grocery" element={<GroceryShop />} />
            <Route path="/industries/market-stall" element={<MarketStall />} />
            <Route path="/industries/restaurant" element={<Restaurant />} />
            <Route
              path="/industries/quick-service"
              element={<QuickService />}
            />
            <Route
              path="/restaurant-overview"
              element={<RestaurantOverview />}
            />

            <Route path="/industries/clothing" element={<Clothing />} />
            <Route path="/industries/home-gift" element={<HomeGift />} />
            <Route path="/industries/wine-liquor" element={<WinLiqure />} />
            <Route path="/industries/garden" element={<Garden />} />
            <Route path="/retail-pos" element={<RetailOverView />} />

            <Route path="/salon-pos" element={<Salon />} />
            <Route path="/barbershop-pos" element={<Barbershop />} />
            <Route path="/med-spa-pos" element={<MedSpa />} />
            <Route path="/nail-salon-pos" element={<NailSalon />} />
            <Route path="/tattoo-piercing-pos" element={<TattooPiercing />} />
            <Route path="/day-spa-pos" element={<DaySpa />} />
            <Route path="/hair-salon-pos" element={<HairSalon />} />
            <Route path="/beauty" element={<BeautyOverView />} />

            <Route path="/pricing" element={<Pricing />} />
            <Route
              path="/data-processing-agreement"
              element={<DataProcessing />}
            />
            <Route path="/about-us" element={<AboutUs />} />

            <Route path="/business-account" element={<BusinessAccount />} />
            <Route path="/visacard" element={<MasterCard />} />
            <Route path="/features" element={<Features />} />
            <Route path="/cash-advance" element={<CashAdvanced />} />
            <Route path="/eligibility" element={<Eligibility />} />

            <Route path="/contact" element={<ContactSales />} />
            <Route path="/help-and-support" element={<Helpandsupport />} />
            <Route path="/partner" element={<Becomepartner />} />
            <Route path="/inventory-management" element={<Inventory />} />

            <Route path="/get-started" element={<SalesForm />} />
            <Route path="/submit-success" element={<SuccessFull />} />
            
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/terms-conditions" element={<TermsCondition />} />
            <Route path="/privacy" element={<PrivacyPolicy />} /> 
            <Route path="/cookie-policy" element={<Cookies />} />
            <Route path="/delivery-terms-conditions" element={<Delivery />} />
            <Route path="/areas" element={<Area />} />
            <Route path="/areas/:path" element={<AreaInfo />} />
            <Route path="/partners" element={<Partners />} />

            {/* <Route path="/shop-catalogue" element={<ProductList />} />
            <Route path="/product-detail" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/delivery-payment" element={<DeliveryPayment />} /> */}

            <Route path="/*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default AppRoutes;